import { render } from "./SliderListComponent.vue?vue&type=template&id=733a493e"
import script from "./SliderListComponent.vue?vue&type=script&lang=js"
export * from "./SliderListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Slider/SliderListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "733a493e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('733a493e', __exports__)) {
    api.reload('733a493e', __exports__)
  }
  
  module.hot.accept("./SliderListComponent.vue?vue&type=template&id=733a493e", () => {
    api.rerender('733a493e', render)
  })

}


export default __exports__